import { render, staticRenderFns } from "./ButtonDashboardList.vue?vue&type=template&id=557194a8&"
import script from "./ButtonDashboardList.vue?vue&type=script&lang=js&"
export * from "./ButtonDashboardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports